export const Logo = ({ variant = "header", shrunk = false }) => {
  const sizeCls =
    variant === "footer"
      ? "h-16 sm:h-20"
      : shrunk
        ? "h-8 sm:h-10"
        : "h-9 sm:h-[52px]";
  return (
    <span data-testid="brand-logo" className="flex items-center max-w-[190px]" aria-label="Westway Collision Center">
      <img
        src="/images/westway-collision-center-logo-reversed-480.webp"
        srcSet="/images/westway-collision-center-logo-reversed-480.webp 480w, /images/westway-collision-center-logo-reversed-960.webp 960w, /images/westway-collision-center-logo-reversed.webp 1200w"
        sizes="(max-width: 640px) 150px, 220px"
        width={1200}
        height={529}
        alt="Westway Collision Center logo, Carrollton TX"
        fetchPriority="high"
        decoding="async"
        className={`${sizeCls} w-auto transition-all duration-500`}
      />
    </span>
  );
};
